module.exports = __webpack_public_path__ + "img/icon_image_cloading@3x.425e1fea.png";